import api from "../../services/api";

export type Prize = {
  id: string;
  tournamentId: string;
  placement: number;
  description: string;
  cashValue?: number | null;
  currency: string;
};

export type Award = {
  id: string;
  tournamentId: string;
  name: string;
  description?: string | null;
  prize?: string | null;
  winnerPlayerId?: string | null;
  winnerClubId?: string | null;
  winnerName?: string | null;
  decidedAt?: string | null;
};

export type PrizeInput = {
  placement: number;
  description: string;
  cashValue?: number | null;
  currency?: string;
};

export type AwardInput = {
  name: string;
  description?: string | null;
  prize?: string | null;
};

/*
  Bare arrays, not the `{ settings }` envelope the registration-settings routes
  use. That envelope has already caused one bug where the wrapper was read as
  the payload; these routes were written not to inherit it.
*/
const getPrizes = async (tournamentId: string): Promise<Prize[]> => {
  const { data } = await api.get<Prize[]>(`/tournaments/${tournamentId}/prizes`);
  return Array.isArray(data) ? data : [];
};

const savePrizes = async (tournamentId: string, prizes: PrizeInput[]): Promise<Prize[]> => {
  const { data } = await api.put<Prize[]>(`/tournaments/${tournamentId}/prizes`, { prizes });
  return data;
};

const getAwards = async (tournamentId: string): Promise<Award[]> => {
  const { data } = await api.get<Award[]>(`/tournaments/${tournamentId}/awards`);
  return Array.isArray(data) ? data : [];
};

const saveAwards = async (tournamentId: string, awards: AwardInput[]): Promise<Award[]> => {
  const { data } = await api.put<Award[]>(`/tournaments/${tournamentId}/awards`, { awards });
  return data;
};

export const prizesAwardsApi = { getPrizes, savePrizes, getAwards, saveAwards };
